/* global google */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Ima = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (!this.flags.isJoined) return 0
    if (!this.isDAI) {
      return this.getDuration() - this.player.getRemainingTime()
    }
    return this.playhead
  },

  /** Override to return video duration */
  getDuration: function () {
    if (!this.isDAI) {
      if (this.player.getCurrentAd && this.player.getCurrentAd()) {
        this.lastDuration = this.player.getCurrentAd().getDuration()
      }
      return this.lastDuration
    }
    return this.duration
  },

  /** Override to return rendition */
  getRendition: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getVastMediaWidth().toString() + 'x' +
        this.player.getCurrentAd().getVastMediaHeight().toString()
    } else {
      if (this.width && this.height) {
        return this.width + 'x' + this.height
      }
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getTitle()
    }
    return this.title
  },

  /** Override to return title2 */
  getTitle2: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getAdvertiserName()
    }
    return this.advertiser
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getMediaUrl()
    }
    return null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return google.ima.VERSION
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'IMA'
  },

  getGivenBreaks: function () {
    return this.player.getCuePoints ? this.player.getCuePoints().length : null
  },

  getBreaksTime: function () {
    if (!this.player.getCuePoints) return
    var cuepoints = this.player.getCuePoints()
    cuepoints.forEach(function (value, index) {
      if (cuepoints[index] === -1 || cuepoints[index] === null || cuepoints[index] === undefined) {
        cuepoints[index] = this.plugin._adapter.getDuration()
      }
    }.bind(this))
    return cuepoints
  },

  getGivenAds: function () {
    return this.totalAds
  },

  getAudioEnabled: function () {
    return this.player.getVolume ? this.player.getVolume() !== 0 : true
  },

  getIsSkippable: function () {
    return this.player.getCurrentAd ? this.player.getCurrentAd().g.skippable : false
  },

  getIsFullscreen: function () {
    if (!this.contentPlayer) {
      for (var key in this.player) {
        var element = this.player[key]
        if (!!element && element.videoHeight && element.clientHeight) {
          this.contentPlayer = element
          break
        }
      }
    }
    if (this.contentPlayer && this.contentPlayer.clientWidth && this.contentPlayer.clientHeight) {
      return (window.innerHeight <= this.contentPlayer.clientHeight + 30 && window.innerWidth <= this.contentPlayer.clientWidth + 30)
    }
    return false
  },

  getIsVisible: function () {
    if (!this.contentPlayer) {
      for (var key in this.player) {
        var element = this.player[key]
        if (!!element && element.videoHeight && element.clientHeight) {
          this.contentPlayer = element
          break
        }
      }
    }
    return youbora.Util.calculateAdViewability(this.contentPlayer)
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    if (this.plugin.getAdapter() && !this.plugin.getAdapter().flags.isJoined) {
      return youbora.Constants.AdPosition.Preroll
    }
    if (this.isDAI && this.plugin.getAdapter() && this.plugin.getAdapter().getIsLive()) return youbora.Constants.AdPosition.Midroll
    return this.adPosition || youbora.Constants.AdPosition.Midroll
  },

  getCreativeId: function () {
    return this.player.getCurrentAd ? this.player.getCurrentAd().g.creativeId : null
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // References
    this.references = []
    if (google.ima.AdEvent) {
      this.monitorPlayhead(true, false)
      var event = google.ima.AdEvent.Type
      // Console all events if logLevel=DEBUG
      youbora.Util.logAllEvents(this.player.addEventListener, [null, event.LOADED, event.CONTENT_PAUSE_REQUESTED])

      this.references[event.LOADED] = this.readyListener.bind(this)
      this.references[event.CONTENT_PAUSE_REQUESTED] = this.playListener.bind(this)
      this.references[event.LOADED] = this.playListener.bind(this)
      this.references[event.PAUSED] = this.pauseListener.bind(this)
      this.references[event.STARTED] = this.playingListener.bind(this)
      this.references[event.RESUMED] = this.playingListener.bind(this)
      this.references[google.ima.AdErrorEvent.Type.AD_ERROR] = this.errorListener.bind(this)
      this.references[event.COMPLETE] = this.endedListener.bind(this)
      this.references[event.CONTENT_RESUME_REQUESTED] = this.endedListener.bind(this)
      this.references[event.SKIPPED] = this.skippedListener.bind(this)
      this.references[event.CLICK] = this.clickListener.bind(this)
      this.references[event.ALL_ADS_COMPLETED] = this.endedViewListener.bind(this)
      this.references[event.LOG] = this.logListener.bind(this)
      this.references[event.FIRST_QUARTILE] = this.firstQuartileListener.bind(this)
      this.references[event.MIDPOINT] = this.secondQuartileListener.bind(this)
      this.references[event.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this)
      this.references[event.CONTENT_RESUME_REQUESTED] = this.breakEndListener.bind(this)
    }
    // DAI
    if (google.ima.dai) {
      var eventDAI = google.ima.dai.api.StreamEvent.Type
      this.references[eventDAI.SKIPPED] = this.skippedL.bind(this)
      this.references[eventDAI.ERROR] = this.errorDAIListener.bind(this)
      this.references[eventDAI.AD_BREAK_STARTED] = this.startDAIListener.bind(this)
      this.references[eventDAI.AD_BREAK_ENDED] = this.stopDAIListener.bind(this)
      this.references[eventDAI.AD_PROGRESS] = this.progressDAIListener.bind(this)
      this.references[eventDAI.CLICK] = this.clickDAIListener.bind(this)
      // this.references[eventDAI.COMPLETE] = this.stopDAIListener.bind(this)
      this.references[eventDAI.STARTED] = this.joinDAIListener.bind(this)
      this.references[eventDAI.FIRST_QUARTILE] = this.firstQuartileListener.bind(this)
      this.references[eventDAI.MIDPOINT] = this.secondQuartileListener.bind(this)
      this.references[eventDAI.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this)
    }
    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  skippedL: function () {
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
    this.fireSkip()
  },

  /** DAI **/
  errorDAIListener: function (e) {
    this.fireError()
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
    this.fireStop()
  },

  startDAIListener: function (e) {
    this.isDAI = true
    this.playhead = 0
    this.adPosition = this.getAdPosition()
    this.duration = null
    this.plugin.fireInit() // if preroll
    this.fireStart()
  },

  progressDAIListener: function (e) {
    if (e.getStreamData && e.getStreamData()) {
      this.playhead = e.getStreamData()['adProgressData']['currentTime']
    } else if (e.getAdData && e.getAdData()) {
      this.playhead = e.getAdData().currentTime
    }
    this.fireJoin()
  },

  clickDAIListener: function (e) {
    this.fireClick()
  },
  stopDAIListener: function (e) {
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
    this.fireStop({ adPlayhead: this.duration })
    if (this.plugin.getAdapter()) this.plugin.getAdapter().fireResume()
    this.fireBreakStop()
  },
  joinDAIListener: function (e) {
    var adData = e.getAd()
    if (adData) {
      this.duration = adData.getDuration()
      this.title = adData.getTitle()
      this.width = adData.getVastMediaWidth()
      this.height = adData.getVastMediaHeight()
      this.advertiser = adData.getAdvertiserName()
    }
    if (this.plugin.getAdapter()) this.plugin.getAdapter().firePause()
    this.fireJoin()
  },

  logListener: function (e) {
    if (e.getAdData() && e.getAdData()['adError']) {
      var error = e.getAdData()['adError']
      this.fireError(error.getErrorCode(), error.getMessage())
    }
  },

  /** Listener for 'play' and 'content_pause_requested' events. */
  playListener: function (e) {
    this.isDAI = false
    this.adPosition = this.getAdPosition()
    var adData = e.getAdData()
    this.totalAds = (adData && adData.adPodInfo) ? adData.adPodInfo.totalAds : null
    this.plugin.fireInit() // if preroll
    if (this.plugin.getAdapter()) this.plugin.getAdapter().firePause()
    this.fireStart({ adPlayhead: '0' })
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' and 'resume' events. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin({ adPlayhead: '0' })
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
    this.fireStop()
  },

  firstQuartileListener: function (e) {
    if (!this.firstQuartileTriggered) {
      this.firstQuartileTriggered = true
      this.fireQuartile(1)
    }
  },

  secondQuartileListener: function (e) {
    if (!this.secondQuartileTriggered) {
      this.secondQuartileTriggered = true
      this.fireQuartile(2)
    }
  },

  thirdQuartileListener: function (e) {
    if (!this.thirdQuartileTriggered) {
      this.thirdQuartileTriggered = true
      this.fireQuartile(3)
    }
  },

  /** Listener for 'ended' and 'content_resume_requested' events. */
  endedListener: function (e) {
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
    this.fireStop({ adPlayhead: this.lastDuration })
  },

  /** Listener for 'skipped' event. */
  skippedListener: function (e) {
    this.fireSkip({ adPlayhead: this.getPlayhead() })
  },

  /** Listener for 'click' event. */
  clickListener: function (e) {
    var url = this.player.getCurrentAd().g.clickThroughUrl
    var now = new Date().getTime()
    if (this.lastUrl === url && now < ((this.lastTime || 0) + 2000)) {
      return
    }
    this.lastUrl = url
    this.lastTime = now
    this.fireClick(url)
  },

  /** Listener for 'allAdsCompleted' event. */
  endedViewListener: function (e) {
    if (this.getPosition() === youbora.Constants.AdPosition.Postroll) {
      this.plugin.fireStop()
    }
  },

  readyListener: function (e) {
    this.totalAds = e.getAdData().adPodInfo.totalAds
  },

  breakEndListener: function (e) {
    this.fireBreakStop()
  },

  getAdPosition: function () {
    if (!this.isDAI) {
      switch (this.player.getCurrentAd().getAdPodInfo().getTimeOffset()) {
        case 0:
          return youbora.Constants.AdPosition.Preroll
        case -1:
          return youbora.Constants.AdPosition.Postroll
      }
      return youbora.Constants.AdPosition.Mdiroll
    } else {
      if (this.plugin.getAdapter()) {
        if (!this.plugin.getAdapter().flags.isJoined || this.plugin.getAdapter().getPlayhead() < 1) {
          return youbora.Constants.AdPosition.Preroll
        }
        return youbora.Constants.AdPosition.Midroll
      }
    }
  }
})

module.exports = youbora.adapters.Ima
